import axios, { AxiosError, AxiosHeaders } from 'axios';

const csrfErrorCodes = ['FST_CSRF_INVALID_TOKEN', 'FST_CSRF_MISSING_SECRET'];

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API || 'http://127.0.0.1:8080',
  withCredentials: true,
});

const getCsrf = async (): Promise<void> => {
  const { data } = await apiClient.get<{ token: string }>('/auth/csrf');

  sessionStorage.setItem('_cto', data.token);
};

apiClient.interceptors.request.use(
  (config) => {
    const headers = new AxiosHeaders({
      'content-type': 'application/json',
      accept: 'application/json',
      'csrf-token': sessionStorage.getItem('_cto'),
    });

    return {
      ...config,
      headers,
    };
  },
  (error: AxiosError) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError<{ code: string }>) => {
    if (!error.response || error.response.status === 401) {
      document.location.href = '/login';
    }

    const initialRequest = error.config;
    const errorCode = error.response.data.code;

    if (csrfErrorCodes.includes(errorCode)) {
      await getCsrf();

      return apiClient(initialRequest);
    }

    return Promise.reject(error.response.data);
  },
);

export default apiClient;
